// Copyright (c) 2023 embyt GmbH. All rights reserved.
// Author: Marc Planeck

import * as React from "react";
import { connect } from "react-redux";
import { defineMessages, FormattedMessage, IntlContext, IntlShape } from "react-intl";

import { IAction, ActionType, raiseAction, IActionTypeSelectGuiItem } from "actions";
import { isSet } from "shared/utils/utils";
import { getSiteSelection, toDropdownItems } from "guiutils";
import { IRegulation } from "shared/types/parameter";
import { IState } from "states/states";
import { EmobilityViewMode } from "states/cachedstates";

import Dropdown from "view/comp/Dropdown";

interface IEMobilitySelectExtProps {
  className?: string;
}

interface IEMobilitySelectProps {
  controlParameters: IRegulation[] | undefined;
  selectedEMobilityViewMode: EmobilityViewMode | undefined;
}

const mapStateToProps = (state: IState, ownProps: IEMobilitySelectExtProps) => {
  const selection = getSiteSelection(state);
  const props: IEMobilitySelectProps = {
    controlParameters: state.para.parameter?.regulation,
    selectedEMobilityViewMode: selection?.eMobilityViewMode,
  };
  return props;
};

interface IEMobilitySelectDispatch {
  onEMoblityWidgetChanged: (selection: EmobilityViewMode) => void;
}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IEMobilitySelectDispatch = {
    onEMoblityWidgetChanged: (selection: EmobilityViewMode) => {
      const payload: IActionTypeSelectGuiItem = { selection };
      dispatch(raiseAction(ActionType.ACT_SELECT_EMOBILITY_WIDGET, payload));
    },
  };
  return dispatchProps;
};

const messages = defineMessages({
  msg_user_caption: {
    id: "Select E-Mobility info",
  },
});

class EMobilitySelectComponent extends React.Component<
  IEMobilitySelectExtProps & IEMobilitySelectProps & IEMobilitySelectDispatch
> {
  static contextType = IntlContext;
  declare context: IntlShape;

  private getViewModeName(viewMode: EmobilityViewMode) {
    return (
      viewMode === EmobilityViewMode.CHARGERLIST ? <FormattedMessage id="Chargers" />
      : viewMode === EmobilityViewMode.RFIDLIST ? <FormattedMessage id="Charging Cards" />
      : <></>
    );
  }

  public render() {
    const eMobilityItems = toDropdownItems(
      [EmobilityViewMode.CHARGERLIST, EmobilityViewMode.RFIDLIST],
      "eMobilityId",
      (name, value) => {
        this.props.onEMoblityWidgetChanged(value);
      },
      (value) => this.getViewModeName(value),
    );

    return (
      <div id="emobilityselect" className={this.props.className}>
        <Dropdown
          items={eMobilityItems}
          caption={this.context.formatMessage(messages.msg_user_caption)}
          curItem={
            isSet(this.props.selectedEMobilityViewMode) ?
              this.getViewModeName(this.props.selectedEMobilityViewMode)
            : this.context.formatMessage(messages.msg_user_caption)
          }
        />
      </div>
    );
  }
}

const ControlCircuitSelect = connect(mapStateToProps, mapDispatchToProps)(EMobilitySelectComponent);

export default ControlCircuitSelect;
